import axios, { AxiosError } from "axios";
import { apiData } from ".";
import { popUp } from "../../features/popUp/PopUp";
import { ApiData } from "./renderAndLoadImage";
import { genDataSceneToSend } from "../../utils/functions/genDataSceneToSend";
import store from "../../redux/store";
import { getDataStaticEnvironment } from "../../utils/functions/getDataStaticEnvironment";

export class genShortUrlApi extends ApiData {
  public async genShortUrl(info: any): Promise<any> {
    const result = genDataSceneToSend(info);
    const environments = getDataStaticEnvironment();
    result.environment = environments;
    try {
      const { data } = await axios.post(
        `${this.baseURL}saveConfiguration`,
        result,
        { headers: { Authorization: `${this.token}` } }
      );
      return data;
    } catch (err: unknown) {
      if (err instanceof AxiosError) {
        popUp({ type: "failure", message: err.message });
        if (err.response) {
          return err.response.data;
        } else {
          return err.message;
        }
      }

      return "Error";
    }
  }
}
